import { render, staticRenderFns } from "./BlackListContactsFilter.vue?vue&type=template&id=653a913a&"
import script from "./BlackListContactsFilter.vue?vue&type=script&lang=ts&"
export * from "./BlackListContactsFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports